module.exports = __webpack_public_path__ + "static/media/ico-see.2f1ff2ad.svg";